import styled from 'styled-components';

export interface LabelInputFileProps {
  isClickable?: boolean
}

export const LabelInputFile = styled.label<LabelInputFileProps>`
  display: flex;
  padding: 10px 10px 10px 15px;
  width: fit-content;
  text-align: center;
  align-items: center;
  margin: 0;
  color: var(--primary);
  background-color: #e5d5ff;
  border-radius: 4px;
  input {
    visibility: hidden;
  }

  :hover {
    cursor: ${(p) => (p.isClickable === true ? 'pointer' : 'auto')};
    ${(p) => (p.isClickable === true ? 'color: #0d6efd !important' : 'red')};
  }

  &.btn-add-file {
    display: flex;
    height: 32px;
    padding: 0 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    background: var(--secondary-p);
    color: var(--primary);
    font-size: 14px;
    font-weight: 700;
    line-height: 140%;
    &:hover {
      color: var(--white);
      background-color: var(--primary);
    }
  }
`;

